export enum REQUEST_TYPES {
	CHANGE_PASSWORD_USER = 'CHANGE_PASSWORD_USER',
	RECOVER_USERS_PASSWORD = 'RECOVER_USERS_PASSWORD',
}
